import { render, staticRenderFns } from "./AlertsDetails.vue?vue&type=template&id=5aa4094c&"
import script from "./AlertsDetails.vue?vue&type=script&lang=js&"
export * from "./AlertsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports